var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuitcase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33917 42.9609C6.86234 42.9609 5.60979 42.4467 4.58152 41.4185C3.55326 40.3902 3.03912 39.1376 3.03912 37.6608V16.7913C3.03912 15.3145 3.55326 14.0619 4.58152 13.0337C5.60979 12.0054 6.86234 11.4913 8.33917 11.4913H15.1239V7.49126C15.1239 6.01443 15.638 4.76186 16.6663 3.73356C17.6946 2.7053 18.9471 2.19116 20.424 2.19116H27.5761C29.0529 2.19116 30.3055 2.7053 31.3337 3.73356C32.362 4.76186 32.8762 6.01443 32.8762 7.49126V11.4913H39.6609C41.1377 11.4913 42.3903 12.0054 43.4185 13.0337C44.4468 14.0619 44.9609 15.3145 44.9609 16.7913V37.6608C44.9609 39.1376 44.4468 40.3902 43.4185 41.4185C42.3903 42.4467 41.1377 42.9609 39.6609 42.9609H8.33917ZM20.424 11.4913H27.5761V7.49126H20.424V11.4913Z",
    fill: "#181A1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuitcase);
export default __webpack_public_path__ + "static/media/suitcase.bdd22dafdcf58319b263bcf976698973.svg";
export { ForwardRef as ReactComponent };